import type { ExcelColumn } from './excel';

export const EXPENSES_XLSX_COLUMNS: ReadonlyArray<ExcelColumn> = [
  { title: '№ расхода',   key: 'expenseId' },
  { title: 'Дата',         key: 'date' },
  { title: 'Поставщик',    key: 'supplier' },
  { title: 'Категория',    key: 'category' },
  { title: 'Наименование', key: 'itemName' },
  { title: 'Кол-во',       key: 'qty' },
  { title: 'Цена',         key: 'unitPrice' },
  { title: 'Сумма',        key: 'total' },
  { title: 'Комментарий',  key: 'note' },
] as const;

export type ExpenseRow = {
  expenseId: string; date: string; supplier: string; category: string;
  itemName: string; qty: number | string; unitPrice: number | string;
  total: number | string; note: string;
};

export function mapExpenseToRows(e: any): ExpenseRow[] {
  const expenseId = e.number ?? e.id ?? e.code ?? '—';
  const date = e.createdAt
    ? new Date(e.createdAt).toLocaleString('ru-RU')
    : (e.date ? new Date(e.date).toLocaleString('ru-RU') : '—');
  const supplier = e.supplier ?? e.vendor ?? '—';
  const category = e.category ?? e.type ?? e.article ?? '—';
  const note = e.note ?? e.comment ?? e.description ?? '';
  const lines = Array.isArray(e.lines) ? e.lines : [];

  if (!lines.length) {
    const qty = Number(e.qty ?? 1);
    const unit = e.price ?? e.unitPrice ?? e.cost ?? '';
    const total = e.total ?? (typeof unit === 'number' ? unit * qty : '');
    return [{ expenseId, date, supplier, category, itemName: e.itemName ?? '—', qty, unitPrice: unit ?? '', total, note }];
  }

  return lines.map((l: any) => {
    const qty = Number(l.qty ?? l.quantity ?? 1);
    const unit = l.unitPrice ?? l.price ?? l.cost ?? '';
    const total = l.total ?? (typeof unit === 'number' ? unit * qty : '');
    return { expenseId, date, supplier, category: l.category ?? category, itemName: l.name ?? '—', qty, unitPrice: unit, total, note };
  });
}

export const getExpenseTime = (e: any) => {
  const v = e.createdAt ?? e.date ?? 0;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : null;
};
